import { Badge, Button, ListSubheader } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { doc, updateDoc } from 'firebase/firestore';
import { useFirestore } from 'utils/firebase';

const SubHeader = ({ notifications, user }) => {
  const database = useFirestore();
  const theme = useTheme();

  const headingClass = {
    display: 'flex',
    justifyContent: 'space-between',
    background: 'white',
  };

  const handleClear = async () =>
    updateDoc(doc(database, 'users', user.uid), { notifications: [] });

  return (
    <ListSubheader sx={headingClass} component="div">
      <Badge
        badgeContent={notifications.length || 0}
        sx={{
          '& .MuiBadge-badge': {
            top: '1.45rem',
            right: '-1.25rem',
          },
        }}
        color="primary"
        overlap="rectangular"
      >
        Notifications
      </Badge>

      <Button
        onClick={handleClear}
        sx={{
          color: theme.palette.primary.main,
          fontSize: '0.85rem',
          padding: '0 10px',
          lineHeight: 1,
          minWidth: 'auto !important',
          minHeight: 'auto !important',

          '& .MuiButton-label': {
            fontSize: '0.7rem',
          },

          '&:hover': {
            background: 'initial',
          },
        }}
      >
        Clear all
      </Button>
    </ListSubheader>
  );
};

export default SubHeader;
